export const GET_ALERTS = 'GET_ALERTS';
export const GET_ALERTS_SUCCESS = 'GET_ALERTS_SUCCESS';

export const GET_ALERT_POINTS = 'GET_ALERT_POINTS';
export const GET_ALERT_POINTS_SUCCESS = 'GET_ALERT_POINTS_SUCCESS';

export const GET_WL_STATISTICS_SUCCESS = 'GET_WL_STATISTICS_SUCCESS';

export const GET_HOSTS_STAT_SUCCESS = 'GET_HOSTS_STAT_SUCCESS';
